import { firestore } from '@psl/functions/firebase/firebaseAccess';
import { docQuery } from '@psl/functions/firebase/rxfireExtensions';
import { PublicConfig } from '@psl/models/ClientModels';
import { shareReplayWithDelay } from '@psl/utils/rxExtensions';
import { defer, map } from 'rxjs';

export const publicConfigQuery$ = defer(() =>
  docQuery(firestore().doc('config/public_config') as any),
).pipe(
  map(config => (config.exists ? config.data() : {}) as Partial<PublicConfig>),
  shareReplayWithDelay({ bufferSize: 1 }, 100 * 1000),
);
